import React, { useState, useEffect } from 'react';
import Promotion from './components/promotion/promotion.component';
import TypeformComponent from './components/typeform/typeform.component';
import Plan from './components/plans/plan.component';
import { fetchPlans, addCartProduct, updateKlaviyoProfile, sendSignupToZapier, sendSignUpEvent } from './services/api';
import { Elements } from '@stripe/react-stripe-js';
import { loadStripe } from '@stripe/stripe-js';
import PaymentForm from './components/paymentForm/paymentForm.component';
import styles from './App.module.scss';
import * as Sentry from '@sentry/react';
import FullLoader from './components/fullLoader/fullLoader.component';
import { useHistory, useLocation } from 'react-router-dom';
import './App.module.scss';
import { get_cookie, set_cookie } from './helper';
import Checkmark from './components/icons/Checkmark';
import { useIntercom } from 'react-use-intercom';
import ThinkingSection from './components/thinking/thinking';
import { getEmail } from './helpers/email';

const stripePromise = loadStripe(window.checkoutConfig.stripe_key);

const steps = ["quiz", "email", "thinking", "start-cooking", "plans", "checkout"];

export function getNextStep(currentId) {
  const index = steps.indexOf(currentId);
  if (index === -1 || index === steps.length - 1) {
    return null; // Not found or already at the last step
  }

  // Skip the thinking step if the user didn't submit the typeform
  if (
    steps[index + 1] === 'thinking' && (!localStorage.getItem('tf_submit') || !localStorage.getItem('ab_thinking'))
  ) {
    return steps[index + 2];
  }

  return steps[index + 1];
}

function App() {
  const history = useHistory();
  const location = useLocation();

  const { boot, shutdown } = useIntercom();

  const url = new URL(window.location.href);
  const stepParam = url.searchParams.get('step');

  const [page, setPage] = useState(stepParam ?? 'quiz');
  const [emailFetched, setEmailFetched] = useState(false);
  const [plans, setPlans] = useState([]);
  const [loading, setLoading] = useState(false);
  const [processingOrder, setProcessingOrder] = useState(false);
  const [scrollTo, setScrollTo] = useState(false);
  const [showSkeleton, setShowSkeleton] = useState(true);
  const [error, setError] = useState(null);
  const [selectedPlanSku, setSelectedPlanSku] = useState("yc_annual-c3z-b");
  const [selectedPlan, setSelectedPlan] = useState(null);
  const [currencySymbol, setCurrencySymbol] = useState('');
  const [cart, setCart] = useState(null);
  const [initCart, setInitCart] = useState(false);
  const [specialOffer, setSpecialOffer] = useState(null);
  const [signupTriggered, setSignupTriggered] = useState(false);
  const [userSubExists, setUserSubExists] = useState(false);

  const appearanceOptions = {
    theme: 'none', // Fully customize the appearance
    variables: {
      fontFamily: 'Gabarito, sans-serif',
      fontSizeBase: '16px',
      borderRadius: '4px',
      colorText: '#2e2e2e',
      spacingUnit: '8px',
      spacingGridRow: '8px', // Override the spacingGridRow variable
      spacingGridColumn: '8px',
    },
    rules: {
      '.Input': {
        background: '#fff',
        border: '1px solid #363636',
        borderRadius: '4px',
        color: '#2e2e2e',
        fontSize: '16px',
        fontWeight: '400',
        padding: '4px 8px',
        height: '39px',
        lineHeight: '39px',
      },
      '.Input--invalid': {
        borderColor: '#e5424d',
      },
      '.Label': {
        fontSize: '0px',
        margin: '0px'
      },
      '.p-GridCell': {
        marginBottom: '16px !important', // Force the marginBottom
        paddingLeft: '0 !important',     // Reset paddingLeft to 0
      },
    },
  };

  const [email, setEmail] = useState('');
  const [emailError, setEmailError] = useState(null);
  let validateTimeout;

  const [elementOptions, setElementOptions] = useState({
    mode: 'payment',
    amount: 10,
    currency: 'usd',
    paymentMethodCreation: 'manual',
    fonts: [
      {
        cssSrc:
          'https://fonts.googleapis.com/css2?family=Gabarito:wght@400..900&display=swap'
      }
    ],
    loader: 'never',
    appearance: appearanceOptions, // Include the appearance object here
  });

  const updateElementOptions = (amount, currency) => {
    setElementOptions({
      mode: 'payment',
      amount: amount,
      currency: currency.toLowerCase(),
      paymentMethodCreation: 'manual',
      loader: 'never',
      fonts: [
        {
          cssSrc:
            'https://fonts.googleapis.com/css2?family=Gabarito:wght@400..900&display=swap'
        }
      ],
      appearance: appearanceOptions, // Include the appearance object here
    });
  };


  // Data for promotional components
  const promotions = [
    {
      id: 1,
      image: '/wp-content/reactpress/apps/yc-checkout/build/assets/promotion1.webp',
      header: 'Get inspired',
      description: 'Travel the world from home to discover the stories of each chef, their food, and their country.'
    },
    {
      id: 2,
      image: '/wp-content/reactpress/apps/yc-checkout/build/assets/promotion2.webp',
      header: 'Learn from the best',
      description: 'Gain the culinary knowledge, techniques, and secrets of the world’s most meaningful chefs.'
    },
    {
      id: 3,
      image: '/wp-content/reactpress/apps/yc-checkout/build/assets/promotion3.webp',
      header: 'Cook delicious',
      description: 'Share your love through food, with hundreds of dishes and flavors from around the world.'
    }
  ];


  const addToCart = (product_id) => {
    // setLoading(true);
    setShowSkeleton(true);
    addCartProduct(product_id, 1)
      .then(data => {
        setCart(data);

      })
      .catch(error => {
        Sentry.captureException(error);
        // console.error('Failed to add to cart:', error);
        setError(error);
      })
      .finally(() => {
        setLoading(false);
        setShowSkeleton(false);
        if (!initCart) setInitCart(true);

        if (!scrollTo) {
          if (window.location.href.indexOf("#membership") > -1) {
            var membershipSection = document.getElementById('membership');
            if (membershipSection) {
              membershipSection.scrollIntoView({ behavior: 'smooth' });
              setScrollTo(true);
            }
          }
        }
      });
  }

  const selectPlan = (plan) => {
    setSelectedPlanSku(plan.product_id);
    setSelectedPlan(plan);

    localStorage.setItem('selected_plan', JSON.stringify(plan));
    let amount;
    if (plan.discounted_price !== null && typeof plan.discounted_price !== 'undefined' && Number(plan.discounted_price) !== 0) {
      amount = Number(plan.discounted_price) * 100;
    } else {
      amount = Number(plan.price) * 100;
    }
    amount = Math.round(amount);
    updateElementOptions(amount, plan.currency.toLowerCase());
    // getCart(plan.product_id);
    addToCart(plan.product_id)
  };

  useEffect(() => {
    const queryParams = new URLSearchParams(window.location.search);
    const currentStep = queryParams.get('step') ?? 'quiz';

    // Set checkout path cookie 
    set_cookie('checkout_path', '/memberships')

    // If form submitted, go to step 2
    const formSubmitted = localStorage.getItem('form_submitted') === 'true' && localStorage.getItem('tf_submit') === '1';
    if (formSubmitted === true && currentStep && ['quiz'].includes(currentStep)) {
      history.push({ search: '?step=email' });
    }

    // Set special offer text
    setSpecialOffer(window.checkoutConfig?.offer_text);
    // Check if the URL contains #membership
    const url_sku = queryParams.get('product_sku');

    fetchPlans()
      .then((plans) => {
        plans = plans.sort((a, b) => {
          const getSortValue = (plan) => {
            if (plan.subscription_period === "lifetime") return 3; // Highest priority
            if (plan.duration_months === 12) return 2; // Second priority
            if (plan.duration_months === 3) return 1;  // Lowest priority
            return 0; // Default
          };
        
          return getSortValue(b) - getSortValue(a);
        });
        console.log("plans",plans);

        setPlans(plans);
        setCurrencySymbol(plans[0].currency_symbol);

        let selected_plan;

        // Check if url has plan
        if (url_sku) {
          selected_plan = plans.find(plan => plan.product_sku === url_sku);
        }

        if(!selected_plan) {
          // Check if local storage has plan
          let stored_plan = localStorage.getItem('selected_plan');
          if (stored_plan) {
            stored_plan = JSON.parse(stored_plan);
            selected_plan = plans.find(plan => plan.product_id === stored_plan.product_id);
          }
        }

        // If no matching plan found, default to annual subscription
        if (!selected_plan) {
          selected_plan = plans.find(plan => plan.subscription_period === 'annual');
        }

        if (selected_plan) {
          setSelectedPlanSku(selected_plan.product_id);
          setSelectedPlan(selected_plan);
          // getCart();
          addToCart(selected_plan.product_id);
          let amount;
          if (selected_plan.discounted_price !== null && typeof selected_plan.discounted_price !== 'undefined' && Number(selected_plan.discounted_price) !== 0) {
            amount = Number(selected_plan.discounted_price) * 100;
          } else {
            amount = Number(selected_plan.price) * 100;
          }
          amount = Math.round(amount);
          updateElementOptions(amount, selected_plan.currency.toLowerCase());
        } else {
          Sentry.captureException('Error fetching plans');
          setError('No suitable plan found');
        }
      })
      .catch(error => {
        setError(error);
        Sentry.captureException(error);
      })
  }, []);

  useEffect(() => {
    const queryParams = new URLSearchParams(location.search);
    const pageParam = queryParams.get('step');
    const submitParam = queryParams.get('submit');

    if(submitParam && submitParam == "1") {
      localStorage.setItem('tf_submit', 1);
    }

    // Show Intercom only on step 5
    if(pageParam === 'checkout') {
      let sheets = document.styleSheets;
      for (let i = 0; i < sheets.length; i++) {
          try {
              let rules = sheets[i].cssRules || sheets[i].rules;
              for (let j = 0; j < rules.length; j++) {
                  if (rules[j].selectorText && rules[j].selectorText.includes(".intercom-lightweight-app, .intercom-namespace")) {
                      sheets[i].deleteRule(j);
                  }
              }
          } catch (e) {
              console.warn("Cannot access stylesheet:", e);
          }
      }
    }

    if (pageParam) {
      setPage(pageParam);
      localStorage.setItem('step_visited', page);
    }
  }, [location.search])

  const goToMembership = () => {
    var membershipSection = document.getElementById('membership');
    if (membershipSection) {
      membershipSection.scrollIntoView({ behavior: 'smooth' });
    }
  }

  const updatePage = (newPage) => {
    history.push({ search: '?step=' + newPage });
    localStorage.setItem('step_visited', newPage);
  };

  const nextPage = async() => {

    if(page == 'email' && email.trim()){
      if (!/^\S+@\S+\.\S+$/.test(email)) {
        setEmailError('Enter a valid email address');
        console.log("INVALID EMAIL");
        return;
      }
      else{
        try {

          // if(signupTriggered) return;

          setEmailError(null);
          localStorage.setItem('email',email);
          set_cookie('email',email,7)

          let tf_uuid = localStorage.getItem('typeform_uuid');
          let userSub = await sendSignUpEvent(email, '', tf_uuid); 
          setUserSubExists(!userSub);

          //Send signup event to VWO
          const VWO = window.VWO;
          VWO.event("signup", {
            "email": email
          });

          window.dataLayer.push({
            event: 'gtm4wp.userRegistered',
            email: email,
            signup_type: 'email',
            visitorEmail: email
          });

          // localStorage.setItem('tracked_email', email);

          if (typeof window.Cookiebot !== 'undefined') {
            window.Cookiebot.submitCustomConsent(true, true, true);
            window.Cookiebot.hide()
          }
          setSignupTriggered(true);


        } catch (error) {
          console.log("userRegistered error: ",error);
          Sentry.captureException('userRegistered error: ', error);
        }
      }
    }

    if(page == 'plans') {
      const email = getEmail();

      if (email) {
        updateKlaviyoProfile(email, {
          'Cart - Plan': selectedPlan.display_name,
          'Cart - Currency': selectedPlan.currency,
          'Cart - Value': selectedPlan.discounted_price ?? selectedPlan.price
        })
        .catch(error => Sentry.captureException(error));
      }
  
      // Trigger add to cart event when the user clicks on continue
      window.dataLayer.push({
        event: 'add_to_cart',
        currency: selectedPlan.currency,
        value: selectedPlan.discounted_price ?? selectedPlan.price,
        items: [
          {
            item_id: selectedPlan.product_sku,
            item_name: selectedPlan.display_name,
            price: selectedPlan.discounted_price ?? selectedPlan.price,
            quantity: 1
          }
        ]
      });
    }

    updatePage(getNextStep(page));
  }

  useEffect(() => {
    if (page == 'checkout') {
      boot();
    }
    else {
      shutdown();
    }

    if (page == 'email') {
      let cookieEmail = get_cookie("email");
      if(cookieEmail){
            //Send signup data to zap
            localStorage.setItem('email',cookieEmail);
            let tf_uuid = localStorage.getItem('typeform_uuid');
            if(tf_uuid){
              sendSignupToZapier(tf_uuid, cookieEmail);

              if (typeof window.Cookiebot !== 'undefined') {
                window.Cookiebot.submitCustomConsent(true, true, true);
                window.Cookiebot.hide()
              }
            }
  
            updatePage(getNextStep(page));
      }
    }

    if (page == 'plans') {
      localStorage.setItem('plans_visited', true);
      const email = getEmail();
      if (email && !get_cookie('plans_page_view')) {
        updateKlaviyoProfile(email, {
           'Plans - Page View': true
        })
        .then(() => set_cookie('plans_page_view', 'true', 7))
        .catch(error => Sentry.captureException(error));
      }
    }

    if (page == 'checkout') {

      const email = getEmail();
      if (email && !get_cookie('checkout_page_view')) {
          updateKlaviyoProfile(email, {
            'Checkout - Page View': true
          })
          .then(() => set_cookie('checkout_page_view', 'true', 7))
          .catch(error => Sentry.captureException(error));
      }
    }

    // Trigger page_view event
    try {
      let pageTitle = '';
      switch (page) {
        case 'quiz':
          pageTitle = 'memberships/typeform';
          break;
        case 'email':
          pageTitle = 'memberships/email';
          break;
        case 'start-cooking':
          pageTitle = 'memberships/overview';
          break;
        case 'plans':
          pageTitle = 'memberships/plans';
          break;
        case 'checkout':
          pageTitle = 'memberships/checkout';
          break;
        default:
          pageTitle = 'memberships';
          break;
      }

      window.dataLayer.push({
        event: 'page_view',
        page_title: pageTitle,
        page_location: window.location.href,
        page_path: window.location.pathname
      });

    } catch (error) {
      Sentry.captureException("page_view event trigger error: ", error);
    }
  }, [page])

  return (
    <>{processingOrder ? <FullLoader /> : null}
      <section className="headerSection" data-page={page}>
        <a class="yc_logo" href="/">
          <svg width="110" height="23" viewBox="0 0 121 23" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M7.78258 12.4515L13.9362 0.951904H15.5642L8.54616 13.8778V22.0197H7.06208V13.9933L-0.0136719 0.951904H1.629L7.78258 12.4515Z" fill="white"></path><path d="M30.046 22.0206H18.5327V0.951904H30.047V2.29207H20.0168V10.2762H29.4841V11.6164H20.0168V20.6804H30.047V22.0206H30.046Z" fill="white"></path><path d="M46.4255 16.5874C46.4255 17.846 46.1084 18.9002 45.474 19.7509C44.8406 20.6006 43.9799 21.2395 42.8945 21.6676C41.8083 22.0948 40.579 22.3084 39.2059 22.3084C38.3506 22.3084 37.5751 22.268 36.8785 22.1855C36.1818 22.1039 35.553 21.9958 34.991 21.861C34.4291 21.7263 33.9176 21.5732 33.4565 21.3999V19.9159C34.2064 20.2037 35.0726 20.4567 36.058 20.6721C37.0425 20.8885 38.116 20.9966 39.2792 20.9966C40.3746 20.9966 41.3472 20.8389 42.197 20.5218C43.0467 20.2046 43.7168 19.7243 44.2072 19.0808C44.6967 18.4373 44.9424 17.6251 44.9424 16.6461C44.9424 15.7817 44.738 15.0731 44.33 14.5204C43.9212 13.9676 43.3089 13.4928 42.493 13.0931C41.6763 12.6944 40.6487 12.2883 39.4094 11.8758C38.545 11.5779 37.7594 11.2634 37.0526 10.9316C36.3468 10.6007 35.7436 10.2157 35.244 9.77844C34.7445 9.34119 34.3622 8.81319 34.0982 8.19352C33.8333 7.57386 33.7022 6.84053 33.7022 5.99536C33.7022 4.83302 33.9974 3.85494 34.5886 3.06294C35.1799 2.27002 35.982 1.6696 36.9958 1.26077C38.0087 0.852854 39.15 0.648438 40.4177 0.648438C41.426 0.648438 42.3849 0.741938 43.2924 0.929855C44.1999 1.11777 45.0771 1.39827 45.9223 1.77319L45.4035 3.05561C44.5583 2.69077 43.7122 2.42219 42.867 2.24894C42.0219 2.0766 41.1859 1.98952 40.36 1.98952C39.37 1.98952 38.489 2.13619 37.7154 2.42952C36.9417 2.72285 36.3294 3.16194 35.8784 3.74769C35.4265 4.33344 35.201 5.07319 35.201 5.96694C35.201 6.88911 35.41 7.63436 35.828 8.20086C36.246 8.76828 36.8418 9.23853 37.6145 9.61344C38.3873 9.98744 39.303 10.3532 40.36 10.7089C41.6085 11.1324 42.6846 11.576 43.5875 12.0417C44.4905 12.5083 45.1899 13.0959 45.684 13.8072C46.178 14.5167 46.4255 15.4444 46.4255 16.5874Z" fill="white"></path><path d="M59.5587 4.36748C58.7034 4.36748 57.9472 4.53339 57.289 4.86523C56.6308 5.19614 56.0781 5.67464 55.6317 6.29889C55.1853 6.92314 54.8461 7.67756 54.616 8.56123C54.385 9.44489 54.2704 10.4395 54.2704 11.5441C54.2704 13.0336 54.4556 14.3041 54.825 15.3556C55.1944 16.4079 55.7692 17.21 56.5465 17.7618C57.3248 18.3146 58.3285 18.5905 59.5587 18.5905C60.4139 18.5905 61.271 18.4942 62.1308 18.3026C62.9907 18.1101 63.9247 17.837 64.934 17.4813V21.2286C64.0017 21.6127 63.0842 21.8896 62.1813 22.0573C61.2783 22.2251 60.2645 22.3094 59.1407 22.3094C56.97 22.3094 55.1853 21.8611 53.7873 20.9628C52.3894 20.0645 51.3545 18.8059 50.6817 17.1871C50.0088 15.5682 49.6733 13.6781 49.6733 11.5166C49.6733 9.92248 49.8897 8.46131 50.3214 7.13581C50.7541 5.81031 51.3875 4.66173 52.2235 3.69189C53.0595 2.72114 54.0917 1.97223 55.3218 1.44331C56.5511 0.91531 57.9637 0.650391 59.5587 0.650391C60.6055 0.650391 61.6551 0.782392 62.7074 1.04731C63.7597 1.31131 64.7653 1.67431 65.726 2.13539L64.285 5.76631C63.4967 5.39231 62.7047 5.06506 61.9072 4.78639C61.1106 4.50681 60.3277 4.36748 59.5587 4.36748Z" fill="white"></path><path d="M86.6816 22.0206H82.2284V12.9272H73.8849V22.0206H69.418V0.951904H73.8849V9.20924H82.2284V0.951904H86.6816V22.0206Z" fill="white"></path><path d="M104.13 22.0206H91.9961V0.951904H104.13V4.61215H96.4639V9.23765H103.597V12.8979H96.4639V18.331H104.13V22.0206Z" fill="white"></path><path d="M112.925 22.0206H108.529V0.951904H120.605V4.61215H112.925V10.0452H120.072V13.6917H112.925V22.0206Z" fill="white"></path></svg>
        </a>
        {page <= 3 && <a href='?step=4'><button class="btn_get_yeschef" type="button">BUY YESCHEF</button></a>}
      </section>
      <div className={`App ${page === 'quiz' || page === 'checkout' ? 'no-margin' : ''}`} style={{ display: processingOrder ? 'none' : 'block' }}>
        {page == 'quiz' && (<section className={styles.typeformSection}>
          <TypeformComponent />
        </section>)}
        {page == 'email' && (<section className={styles.emailSection}>
          <div className={`${styles.emailInputContainer}`}><div className={styles.emailInput}>
            {/* <label className={styles.inputLabel}>Email Address</label> */}
            <h1 className={styles.emailSectionHeading}>Begin your culinary journey</h1>
            <div className={styles.emailSectionSubHeading}>Enter your email to get started</div>
            <input
              type="text"
              value={email}
              onChange={(e) => {
                setEmail(e.target.value);
                // clearTimeout(validateTimeout);
                // if (checkErrors) validateTimeout = setTimeout(() => validateFields(), 800);
              }}
              placeholder="Your email address"
              // className={`${styles.inputField} ${errors.email ? styles.inputError : ''}`} 
              />
            {emailError && <div className={styles.errorMsg}>{emailError}</div>}
          </div></div>
        </section>)}
        {page == 'thinking' && <ThinkingSection updatePage={updatePage} />}
        {page == 'start-cooking' && (<section className="promotions-section">
          <h1 className="promotionsTitle__desktop">Start cooking better today</h1>
          <h1 className="promotionsTitle__mobile">Start cooking better today</h1>
          <div className='promotions-container' onClick={() => goToMembership()}>
            {promotions.map(promotion => (
              <Promotion
                key={promotion.id}
                image={promotion.image}
                header={promotion.header}
                description={promotion.description}
              />
            ))}
          </div>
        </section>)}
        {/* {loading && <Loader/>} */}
        {error && <div>Error fetching plans: {error}</div>}
        {page == 'plans' && (<section id="membership" className="plans-section">
          <h1>Choose your membership</h1>
          <p className={styles.choosePlanDescription}>Every plan includes:</p>
          <div className={styles.membershipBenefitsList}>
            <div className={styles.membershipBenefitsListItem}><Checkmark /><span>Unlimited access to all classes</span></div>
            <div className={styles.membershipBenefitsListItem}><Checkmark /><span>Watch on mobile, web or TV</span></div>
            <div className={styles.membershipBenefitsListItem}><Checkmark /><span>100s of Step-by-step lessons</span></div>
            <div className={styles.membershipBenefitsListItem}><Checkmark /><span>PDF Cookbooks, and more!</span></div>
          </div>
          {/* {specialOffer && <div className={styles.specialOffer}>{specialOffer}</div>} */}
          <div className="plans-container">
          {plans.filter((plan) => !plan.hidden).map((plan) => {
            const annualPlan = plans.filter((plan) => plan.subscription_period === 'annual')?.[0];

            return (
              <Plan
                key={plan.product_id}
                product_sku={plan.product_id}
                title={plan.title}
                displayName={plan.display_name}
                price={plan.price}
                bogo={plan.bogo}
                discounted_price={plan.discounted_price}
                subscription_period={plan.subscription_period}
                showSavings={plan.showSavings}
                planOfferText={plan.plan_offer_text}
                planUpgradeText={plan.plan_upgrade_text}
                savingAmount={plan.saving_amount}
                isPopular={plan.subscription_period === 'annual'}
                planInfo={plan.planInfo}
                discountToAnnual={annualPlan ? Number(plan?.discounted_price ?? plan?.price)*12/Number(plan.duration_months) - Number(annualPlan?.discounted_price ?? annualPlan?.price): 0}
                show_monthly_price={plan.show_monthly_price}
                currency_symbol={plan.currency_symbol}
                duration_months={parseInt(plan.duration_months)}
                selected={selectedPlanSku === plan.product_id}
                onClick={() => selectPlan(plan)}
              />
            );
          })}
          </div>
          <div className={styles.MoneyBackGuarantee}>
            {/*<div className={styles.Includes}>All Plans include</div>*/}
            <div className={styles.ThirtyDaysMoneyBack}>30-Day Money-Back Guarantee</div>
          </div>
          </section>)}
        {page == 'checkout' && (<section className={styles.paymentSection}>
          <Elements stripe={stripePromise} options={elementOptions}>
            <PaymentForm
              cart={cart}
              setCart={setCart}
              selectedPlan={selectedPlan}
              loading={loading}
              setLoading={setLoading}
              currency_symbol={currencySymbol}
              showSkeleton={showSkeleton}
              setShowSkeleton={setShowSkeleton}
              setProcessingOrder={setProcessingOrder}
              initCart={initCart}
              signupEmailStep={signupTriggered}
              userSubExists={userSubExists}
            />
          </Elements>
        </section>)}
        {page !== 'quiz' && page !== 'checkout' && page !== 'thinking' && (<section className={styles.paginationSection}>
          {/* {page > 1 && (
            <button className={styles.previousButton} onClick={previousPage}>
              Previous
            </button>
          )} */}
          {page !== 'checkout' && (<button className={styles.nextButton} onClick={nextPage}>
            Continue
          </button>)}

        </section>)}
        {page == 'email' && <p className={styles.emailSectionDescription}>By continuing you accept our <u><a href="https://yeschef.me/terms" className={styles.link}>Terms</a></u> and <u><a href="https://yeschef.me/privacy" className={styles.link}>Privacy Policy</a></u>.</p>}

      </div>
    </>
  );
}

export default App;